import type { FC, ReactNode } from 'react'
import type { LogoProps } from '@/types'

export const Logo: FC<LogoProps> = ({
    width = 30,
    height = 30,
    className
}): ReactNode => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            aria-hidden='true'
        >
            <path
                d='M16 30 L16 15'
                stroke='currentColor'
                strokeWidth='2.4'
                strokeLinecap='round'
            />
            <path
                d='M16 18.5 C 9.8 18.5 5.8 14 6.8 6.9 C 13 7.5 16 12 16 18.5 Z'
                fill='currentColor'
            />
            <path
                d='M16 18.5 C 22.2 18.5 26.2 14 25.2 6.9 C 19 7.5 16 12 16 18.5 Z'
                fill='currentColor'
                opacity='0.6'
            />
        </svg>
    )
}
